var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 759,
    height: 587,
    viewBox: "0 0 759 587",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_38)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "history-line",
    d: "M604.839 -12C920.839 205 -21.2133 -55.8117 20.3384 37C73.8384 156.5 793.516 74.7774 676.838 200.5C612.338 270 -46.7018 243.709 32.3382 324C111.378 404.291 776.756 370.434 742.338 449C699.316 547.207 102.526 418.494 200.576 572.5",
    stroke: "#C1C8E2",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.269 271.745H313.519C308.819 271.745 305.06 267.801 305.06 262.872C305.06 257.943 308.819 254 313.519 254H364.269C368.968 254 372.727 257.943 372.727 262.872C372.727 267.801 368.968 271.745 364.269 271.745Z",
    fill: "#0B132B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.269 371.113H313.519C308.819 371.113 305.06 367.17 305.06 362.241C305.06 357.312 308.819 353.369 313.519 353.369H364.269C368.968 353.369 372.727 357.312 372.727 362.241C372.727 367.17 368.968 371.113 364.269 371.113Z",
    fill: "#0B132B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.433 296.586H299.123C294.506 296.586 290.813 292.643 290.813 287.714C290.813 282.785 294.506 278.841 299.123 278.841H307.433C312.05 278.841 315.743 282.785 315.743 287.714C315.743 292.643 312.05 296.586 307.433 296.586Z",
    fill: "#0B132B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.19 321.433H281.548C276.799 321.433 273 317.49 273 312.561C273 307.631 276.799 303.688 281.548 303.688H307.19C311.939 303.688 315.737 307.631 315.737 312.561C315.737 317.49 311.939 321.433 307.19 321.433Z",
    fill: "#0B132B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.786 321.433H374.144C369.395 321.433 365.596 317.489 365.596 312.56C365.596 307.631 369.395 303.688 374.144 303.688H399.786C404.534 303.688 408.333 307.631 408.333 312.56C408.333 317.489 404.534 321.433 399.786 321.433Z",
    fill: "#0B132B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.068 296.586H331.318C326.619 296.586 322.86 292.643 322.86 287.714C322.86 282.785 326.619 278.841 331.318 278.841H382.068C386.767 278.841 390.527 282.785 390.527 287.714C390.527 292.643 386.767 296.586 382.068 296.586Z",
    fill: "#3454D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.068 346.274H331.318C326.619 346.274 322.86 342.331 322.86 337.402C322.86 332.473 326.619 328.529 331.318 328.529H382.068C386.767 328.529 390.527 332.473 390.527 337.402C390.527 342.331 386.767 346.274 382.068 346.274Z",
    fill: "#3454D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.899 321.433H330.873C326.421 321.433 322.86 317.489 322.86 312.56C322.86 307.631 326.421 303.688 330.873 303.688H346.899C351.351 303.688 354.913 307.631 354.913 312.56C354.913 317.489 351.351 321.433 346.899 321.433Z",
    fill: "#3454D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.433 346.272H299.123C294.506 346.272 290.813 342.329 290.813 337.4C290.813 332.471 294.506 328.527 299.123 328.527H307.433C312.05 328.527 315.743 332.471 315.743 337.4C315.743 342.329 312.05 346.272 307.433 346.272Z",
    fill: "#0B132B"
  }), /*#__PURE__*/React.createElement("g", {
    className: "history-ball"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 21,
    r: 11,
    fill: "#F1F1FB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 21,
    r: 4,
    fill: "#3D40D5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 759,
    height: 587,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.91960637.svg";
export { ForwardRef as ReactComponent };